import styled from 'styled-components';

export const ContentWrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 12px 24px;
  border-top: 1px solid #888;
`;

export const SectionTitle = styled.h1`
  padding: 0 8px;
  margin: 0;
`;

export const AvailableIntWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 16px;
`;

export const PartnerCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin: 0 32px;
`;

export const PartnerLogoWrapper = styled.div`
  height: 140px;
  width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;
